export const ContactUs = {
    Title: 'Contact Us',
    Paragraphs: {
        DescribeIssue: 'Please describe the issue',
        WeWillReviewMsg: 'We will review your message and get back to you as soon as possible',
        YouWillBeContacted: 'You will be contacted via this email:'

    },
    Headers: {
        RequestSent: 'Request sent!'
    },
    Buttons: {
        Send: {
            label: 'Send'
        },
        Close: {
            label: 'Close'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/ContactUs.ts